module.exports = __webpack_public_path__ + "img/123.e8cf391f.png";